import React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import NodeProjectTeaser from './Teaser';
import NodeProjectPage from './Page';
import { NodeProject } from '../../../types/uncinc_profile/nodes';

interface NodeProjectProps {
  entity: ImmutableEntity<NodeProject>;
  viewMode: string;
  classes: string;
}

const NodeProjectWrapper: React.FC<NodeProjectProps> = ({ entity, viewMode, classes = '' }) => {
  switch (viewMode) {
    case 'teaser':
      return <NodeProjectTeaser entity={entity} classes={classes} />;
    default:
      return <NodeProjectPage entity={entity} />;
  }
};

export default NodeProjectWrapper;
